import { render } from "./CampaignList.vue?vue&type=template&id=cc91b352&scoped=true"
import script from "./CampaignList.vue?vue&type=script&lang=js"
export * from "./CampaignList.vue?vue&type=script&lang=js"

import "./CampaignList.vue?vue&type=style&index=0&id=cc91b352&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc91b352"]])

export default __exports__